export interface LanguageOption {
  code: string;
  label: string;
  flag: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'en-US', label: 'English (US)', flag: '🇺🇸' },
  { code: 'en-GB', label: 'English (UK)', flag: '🇬🇧' },
  { code: 'es-ES', label: 'Spanish (Spain)', flag: '🇪🇸' },
  { code: 'es-MX', label: 'Spanish (Mexico)', flag: '🇲🇽' },
  { code: 'fr-FR', label: 'French (France)', flag: '🇫🇷' },
  { code: 'fr-CA', label: 'French (Canada)', flag: '🇨🇦' },
  { code: 'de-DE', label: 'German', flag: '🇩🇪' },
  { code: 'it-IT', label: 'Italian', flag: '🇮🇹' },
  { code: 'pt-BR', label: 'Portuguese (Brazil)', flag: '🇧🇷' },
  { code: 'pt-PT', label: 'Portuguese (Portugal)', flag: '🇵🇹' },
  { code: 'zh-CN', label: 'Chinese (Simplified)', flag: '🇨🇳' },
  { code: 'zh-TW', label: 'Chinese (Traditional)', flag: '🇹🇼' },
  { code: 'ja-JP', label: 'Japanese', flag: '🇯🇵' },
  { code: 'ko-KR', label: 'Korean', flag: '🇰🇷' },
  { code: 'ar-SA', label: 'Arabic', flag: '🇸🇦' },
  { code: 'hi-IN', label: 'Hindi', flag: '🇮🇳' },
  { code: 'ru-RU', label: 'Russian', flag: '🇷🇺' },
  { code: 'nl-NL', label: 'Dutch', flag: '🇳🇱' },
  { code: 'pl-PL', label: 'Polish', flag: '🇵🇱' },
  { code: 'tr-TR', label: 'Turkish', flag: '🇹🇷' },
  { code: 'vi-VN', label: 'Vietnamese', flag: '🇻🇳' },
  { code: 'th-TH', label: 'Thai', flag: '🇹🇭' },
  { code: 'id-ID', label: 'Indonesian', flag: '🇮🇩' },
  { code: 'ms-MY', label: 'Malay', flag: '🇲🇾' },
  { code: 'fil-PH', label: 'Filipino', flag: '🇵🇭' },
  { code: 'sv-SE', label: 'Swedish', flag: '🇸🇪' },
  { code: 'da-DK', label: 'Danish', flag: '🇩🇰' },
  { code: 'no-NO', label: 'Norwegian', flag: '🇳🇴' },
  { code: 'fi-FI', label: 'Finnish', flag: '🇫🇮' },
  { code: 'el-GR', label: 'Greek', flag: '🇬🇷' },
  { code: 'cs-CZ', label: 'Czech', flag: '🇨🇿' },
  { code: 'ro-RO', label: 'Romanian', flag: '🇷🇴' },
  { code: 'hu-HU', label: 'Hungarian', flag: '🇭🇺' },
  { code: 'he-IL', label: 'Hebrew', flag: '🇮🇱' },
  { code: 'uk-UA', label: 'Ukrainian', flag: '🇺🇦' },
];

export const getLanguageByCode = (code: string): LanguageOption | undefined => {
  return LANGUAGE_OPTIONS.find((lang) => lang.code === code);
};

export const filterLanguages = (search: string): LanguageOption[] => {
  if (!search) return LANGUAGE_OPTIONS;
  const searchLower = search.toLowerCase();
  return LANGUAGE_OPTIONS.filter(
    (lang) =>
      lang.label.toLowerCase().includes(searchLower) ||
      lang.code.toLowerCase().includes(searchLower)
  );
};
